<template>
  <div class="c-page-footer -right">
    <a class="c-button-white -logout pointer" @click="emit('click')" name="S6-1-logout-btn">
      <span class="label">
        <slot></slot>
      </span>
    </a>
  </div>
</template>

<script setup lang="ts">
  const emit = defineEmits<{
    (e: 'click'): void
  }>()
</script>